import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import './OrderModal.css';

function OrderModal({ dish, onClose, onSubmit, isCartOrder = false, submitting = false, maxTables = null }) {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    tableNumber: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.mobile && formData.tableNumber) {
      setError('');
      if (!submitting) onSubmit(formData);
    } else {
      setError('Please fill in all fields before placing the order.');
    }
  };

  return (
    <div className="order-modal-overlay" onClick={onClose}>
      <div className="order-modal" onClick={(e) => e.stopPropagation()}>
        <button className="order-modal-close" onClick={onClose}>
          <FaTimes />
        </button>
        
        {!isCartOrder && (
          <div className="order-modal-header">
            <img src={dish.image} alt={dish.name} className="order-dish-image" />
            <h2 className="order-dish-name">{dish.name}</h2>
            <p className="order-dish-price">
              {new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                maximumFractionDigits: 0
              }).format(dish.price)}
            </p>
          </div>
        )}
        {isCartOrder && (
          <div className="order-modal-header">
            <h2 className="order-dish-name">Place Order for Cart Items</h2>
            <p className="order-dish-price">Please provide your details to place the order</p>
          </div>
        )}

        <form className="order-form" onSubmit={handleSubmit}>
          {error && (
            <div className="order-modal-error">
              {error}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="name">Your Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter mobile number"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="tableNumber">Table Number</label>
            <input
              type="number"
              id="tableNumber"
              name="tableNumber"
              value={formData.tableNumber}
              onChange={handleChange}
              placeholder={maxTables ? `Enter table number (1-${maxTables})` : 'Enter table number'}
              required
              min="1"
              max={maxTables || undefined}
            />
          </div>

          <button type="submit" className="order-submit-btn" disabled={submitting}>
            {submitting ? 'Placing Order…' : isCartOrder ? 'Place All Orders' : 'Place Order'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default OrderModal;

